import type { FieldState } from './interface';

export const defaultState: FieldState = {
  visible: true,
  preserve: true,
};
